import { useStoreLogin } from "@/store/login";
import { fetchWithOutToken } from "@/utils/fetchApi";
import { fetchWithToken_old } from "@/utils/fetchApi";
import { fetchWithOutToken_old } from "@/utils/fetchApi";

export const resetPasswordByOtp = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/sent-reset-password-otp",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error(
      "Error in sent otp to reset Password:",
      response?.details?.message
    );
    return { response };
  } else {
    return response;
  }
};

export const changeLoginPassword = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/reset-password",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in change Password:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const getOtpRegister = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/signup-with-otp",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in sent otp:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const fileUrlUpload = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/file/upload",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in sent otp:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};
export const sendOtp = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/send-mobile-otp-gverify",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in sent otp:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const verifyOtp = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/verify-otp",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in sent otp:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const summitRegisterData = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/public/user/register-student-with-otp",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in submit Data:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};
export const getInitialData = async (path, params = {}) => {
  const response = await fetchWithOutToken(
    `/api/s/dynamic-page/${path}`,
    params
  );
  if (response.error) {
    console.error("Error fetching initial Data:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getProductById = async (id, params) => {
  const response = await fetchWithOutToken(`/api/s/product/${id}`, params);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getQuiz = async (id = "") => {
  const response = await fetchWithOutToken_old(
    `/api/student/quiz/quizwindow/data/${id}`
  );
  if (response.error) {
    console.error("Error in sent otp:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const quizSubmit = async (userId = "", quizId = "", data) => {
  const response = await fetchWithOutToken_old(
    `/api/student/quiz/quizwindow/${userId}/submit/${quizId}`,
    data,
    {
      method: "PUT",
    }
  );
  if (response.error) {
    console.error("Error in sent otp:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const getParticipants = async (params = {}) => {
  const response = await fetchWithToken_old(
    `/api/ims/quiz/participants`,
    params
  );
  if (response.error) {
    console.error("Error in fetchinig", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const getQuizReoprt = async (params = {}) => {
  const response = await fetchWithToken_old(`/api/student/quiz/report`, params);
  if (response.error) {
    console.error("Error in fetchinig", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const getAuthToken = async () => {
  const refreshToken = useStoreLogin.getState().refreshToken;
  const params = {
    refreshToken,
  };
  const response = await fetchWithOutToken("/api/auth/getAuthToken", params, {
    method: "POST",
  });
  if (response.error) {
    console.error("Error fetching area by ID:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getWebsiteData = async (id, params = {}) => {
  const response = await fetchWithOutToken(`/api/s/website/${id}/data`, params);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getPageData = async (url, params = {}) => {
  const response = await fetchWithOutToken(`/api/s/frontPage/${url}`, params);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getAllBlogCategory = async () => {
  const response = await fetchWithOutToken(`/api/s/blogpostcategory`);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getAddressByPin = async (pin) => {
  const response = await fetchWithOutToken(`/api/i/ims/pincode/${pin}`);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getQuizAll = async () => {
  const response = await fetchWithOutToken_old(`/api/student/all/quizgroup`);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};
export const getQuizAllById = async (id) => {
  const response = await fetchWithOutToken_old(
    `/api/student/quizgroup/quiz/${id}`
  );
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getVideoBYId = async (id = {}) => {
  const response = await fetchWithOutToken(`/api/s/galleryvideo`, {
    album: id,
  });
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getCourses = async (params) => {
  const response = await fetchWithOutToken(`/api/p/courses`, params);
  if (response.error) {
    console.error("Error fetching courses:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};
export const getDownload = async (params) => {
  const response = await fetchWithOutToken(`/api/s/download`, params);
  if (response.error) {
    console.error("Error fetching courses:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};


export const getCoursesAll = async () => {
  const response = await fetchWithOutToken_old(`/api/public/data/all-courses`);
  if (response.error) {
    console.error("Error fetching courses:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getSession = async () => {
  const response = await fetchWithOutToken_old(`/api/public/data/sessions`);
  if (response.error) {
    console.error("Error fetching session:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getAllCenters = async () => {
  const response = await fetchWithOutToken_old(`/api/public/data/centers`);
  if (response.error) {
    console.error("Error fetching center:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getStream = async () => {
  const response = await fetchWithOutToken("/api/p/streams");
  if (response.error) {
    console.error("Error fetching in stream:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};
export const getStreamAll = async () => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/all-stream?status=true`
  );
  if (response.error) {
    console.error("Error fetching in stream:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getCourseProgramByUri = async (url, params = {}) => {
  const response = await fetchWithOutToken(
    `/api/s/courseprogram-by-uri/${url}`,
    params
  );
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};
export const getWebberListItem = async (params = {}) => {
  const response = await fetchWithOutToken(`/api/s/webberlistitem`, params);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};
export const getTestimonial = async (params = {}) => {
  const response = await fetchWithOutToken(`/api/s/testimonial`, params);
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const createEnquiry = async (data) => {
  const response = await fetchWithOutToken_old("/api/enquiry/enquiry", data, {
    method: "POST",
  });
  if (response.error) {
    console.error("Error in Enquiry:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};


export const getPopup = async (params = {}) => {
  const response = await fetchWithOutToken(`/api/s/popup`, params);
  if (response.error) {
    console.error("Error fetching popup data:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

// Buy Module Api

export const getProductResponse = async (id) => {
  const response = await fetchWithOutToken(
    `https://v3.edkt.net/api/s/product/${id}`
  );
  if (response.error) {
    console.error("Error fetching get Product Response:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getCourseById = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/courses`,
    params
  );
  if (response.error) {
    console.error("Error fetching course By Id :", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getProduct = async (ids = {}) => {
  const response = await fetchWithOutToken(`/api/s/product`, ids);
  if (response.error) {
    console.error("Error fetching course By Id :", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const placeOrder = async (data) => {
  const response = await fetchWithOutToken_old(
    "/api/cmn/order/place-order",
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in Place order:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const getProductBatch = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/product-batches`,
    params
  );
  if (response.error) {
    console.error("Error in fetching Product Batch :", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const initiateOrderPost = async (orderData) => {
  const response = await fetchWithToken_old(
    "/api/cmn/order/place-order",
    orderData,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error fetching area by ID:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};
export const putAddress = async (address) => {
  const response = await fetchWithToken_old(
    "/api/student-manager/student/address",
    address,
    {
      method: "PUT",
    }
  );
  if (response.error) {
    console.error("Error fetching area by ID:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getPaymentNodes = async (id) => {
  const response = await fetchWithToken_old(`/api/cmn/order/payment-nodes`, {
    order: id,
  });
  if (response.error) {
    console.error("Error fetching booking type:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getPayMentNode = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/cmn/order/payment-nodes`,
    params
  );
  if (response.error) {
    console.error("Error fetching PayMent Node:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const applyCouponCode = async (id, data) => {
  const response = await fetchWithToken_old(
    `/api/cmn/order/${id}/add-discount`,
    data,
    {
      method: "POST",
    }
  );
  if (response.error) {
    console.error("Error in Coupon Apply:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const checkDiscountCode = async (productId, couponCode) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/get-coupon-discount`,
    { code: couponCode, product: productId }
  );
  if (response.error) {
    console.error("Error fetching area by ID:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getCouponCodeDiscount = async (params = {}) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/get-coupon-discount`,
    params
  );
  if (response.error) {
    console.error("Error in Coupon Apply:", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};

export const getEmiPaymentOptions = async (id) => {
  const response = await fetchWithOutToken_old(
    `/api/public/data/product/${id}/payment-options`
  );
  if (response.error) {
    console.error("Error fetching courses:", response.error);
    return { error: response.error, details: response?.details };
  }
  return response;
};

export const getpostal = async (postalCode) => {
  const response = await fetchWithOutToken(`/api/s/pincode/${postalCode}`);
  if (response.error) {
    console.error("Error in fetchinig", response?.details?.message);
    return { response };
  } else {
    return response;
  }
};
